import axios from 'axios';

const setAuthHeader = (token) => {
  const currentUserLanguage = localStorage.getItem('userLanguage');

  axios.defaults.headers.common.Authorization = token ? `Bearer ${token}` : '';
  axios.defaults.headers.common['Accept-Language'] = currentUserLanguage || 'en-US';
};

export default setAuthHeader;
